import React, { useEffect } from 'react'
import { BrowserRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom'
import { AnonymousUsers } from './Pages/AnonymousUsers/AnonymousUsers'
import { Dashboard } from './Pages/Dashboard/Dashboard'
import { Login } from './Pages/Login/Login'
import { PhoneVerifications } from './Pages/PhoneVerifications/PhoneVerifications'
import { Posts } from './Pages/Posts/Posts'
import { Users } from './Pages/Users/Users'
import { getUser } from './utils/hooks'

export const Routes = () => {
  const user = getUser()
  return (
    <BrowserRouter>
        <Switch>
        <Route exact path={"/posts"} component={() => <PrivateRoute>
              <Posts />
          </PrivateRoute>} />
        <Route exact path={"/users"} component={() => <PrivateRoute>
              <Users />
          </PrivateRoute>} />
        <Route exact path={"/anonymous"} component={() => <PrivateRoute>
              <AnonymousUsers />
          </PrivateRoute>} />
        <Route exact path={"/phone-verifications"} component={() => <PrivateRoute>
              <PhoneVerifications />
          </PrivateRoute>} />
        <Route exact path={"/"} component={() => <PrivateRoute>
              <Dashboard />
          </PrivateRoute>} />
          {(!user?.id) && (
            <>         
              <Route
                exact
                path={"/signin"}
                component={Login}
              />
            </>
          )}
          <Redirect to={'/'} />
      </Switch>
      </BrowserRouter>
  )
}

const PrivateRoute = (props) => {
  const history = useHistory()
  const user = getUser()

  useEffect(() => {
    if (!user?.id) {
      history.push(`/signin`)
    }
  }, [])

  if (user?.id) {
    return props.children
  }

  return null
}